import {removeItem} from '../../common/util/array';

export const removeOrder = (list, item) => {
  const index = list.findIndex((element) =>
    element.orderSequence === item.orderSequence && element.orderCode === item.orderCode);
  
  return index > -1 ? removeItem(list, index) : list;
};
